import Cookies from "js-cookie";
export const isAuthenticated = () =>
  localStorage.getItem(process.env.REACT_APP_NAME) !== null;
export const getToken = () => localStorage.getItem(process.env.REACT_APP_NAME);
export const saveToken = (token) => {
  localStorage.setItem(process.env.REACT_APP_NAME, token);
};
export const logout = () => {
  localStorage.removeItem(process.env.REACT_APP_NAME);

  Cookies.remove("userData");
};
